import { CalculationField } from "../models/CalculationField";
import { CalculationFieldType } from "../models/CalculationFieldType";

export type CalculationJsonEditorType = 'object' | 'array' | 'string' | 'number' | 'integer' | 'boolean' | 'null';

export type CalculationJsonEditorSchema = {
    type: CalculationJsonEditorType
    properties: any
    additionalProperties: boolean,
    minProperties?: number,
    not?: any,
    required: Array<string>
}

export class CalculationsJsonCalculationConfigurationService {

    public static getJsonEditorSchemaForField(field: CalculationField): CalculationJsonEditorSchema {
        if (field == null) throw new Error("field is required!");

        const schema: any = {
            properties: {},
            additionalProperties: true
        };

        const schemaType: CalculationJsonEditorType | null = this.getSchemaTypeForFieldType(field.field_type);
        if (schemaType !== null) {
            schema.type = schemaType;
        }

        return schema;
    }

    private static getSchemaTypeForFieldType(fieldType: CalculationFieldType | any): CalculationJsonEditorType | null {
        switch (fieldType) {
            case CalculationFieldType.Text:
                return 'string';
            case CalculationFieldType.Number:
                return 'number';
            case CalculationFieldType.Boolean:
                return 'boolean';
            case CalculationFieldType.Array:
                return 'array';
            case CalculationFieldType.Object:
            case CalculationFieldType.Json:
                return 'object';
            default:
                return null;
        }
    }

    public static getJsonEditorSchemaForCalculation(): CalculationJsonEditorSchema {
        return {
            type: 'object',
            required: ["type"],
            properties: {
                type: { type: "string" },
                description: { type: "string" }
            },
            additionalProperties: true
        };
    }
}
